var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronArrowRightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.775 9.69492L7.275 14.1949C7.125 14.3449 6.975 14.4199 6.75 14.4199C6.525 14.4199 6.375 14.3449 6.225 14.1949C5.925 13.8949 5.925 13.4449 6.225 13.1449L10.2 9.16992L6.225 5.19492C5.925 4.89492 5.925 4.44492 6.225 4.14492C6.525 3.84492 6.975 3.84492 7.275 4.14492L11.775 8.64492C12.075 8.94492 12.075 9.39492 11.775 9.69492Z",
    fill: "#4F4F4F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8194_57956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 3,
    width: 6,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.775 9.69492L7.275 14.1949C7.125 14.3449 6.975 14.4199 6.75 14.4199C6.525 14.4199 6.375 14.3449 6.225 14.1949C5.925 13.8949 5.925 13.4449 6.225 13.1449L10.2 9.16992L6.225 5.19492C5.925 4.89492 5.925 4.44492 6.225 4.14492C6.525 3.84492 6.975 3.84492 7.275 4.14492L11.775 8.64492C12.075 8.94492 12.075 9.39492 11.775 9.69492Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8194_57956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.169922H18V18.1699H0V0.169922Z",
    fill: "#4F4F4F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronArrowRightIcon);
export default __webpack_public_path__ + "static/media/ChevronArrowRightIcon.8ce71b8da7e2db4b1b0cf195090911f4.svg";
export { ForwardRef as ReactComponent };